export default __webpack_public_path__ + "static/media/tdu-for-home-page.060739e4.png";